module.exports = __webpack_public_path__ + "static/img/squad_template_green.df03c92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/squad_template_green.png
// module id = emU/
// module chunks = 94